"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromGeoportalLayers = void 0;
var tslib_1 = require("tslib");
var ArcGISDynamicMapServiceLayer_1 = tslib_1.__importDefault(require("esri/layers/ArcGISDynamicMapServiceLayer"));
var ArcGISTiledMapServiceLayer_1 = tslib_1.__importDefault(require("esri/layers/ArcGISTiledMapServiceLayer"));
/**
 * Creates an operational layer from a GeoPortal config file layer definition.
 * @param configLayer GeoPortal config file layer definition
 * @returns a LayerList operational layer.
 */
function configLayerToOpLayer(configLayer) {
    var layerType = configLayer.layerType, url = configLayer.url;
    var title = configLayer.options.id;
    // Replace non-alphanumeric characters with underscore.
    var id = title.replace(/[^a-z0-9]+/gi, "_");
    var visible = configLayer.options.visible || false;
    var opacity = configLayer.options.opacity;
    // Create layer object matching layerType string.
    var layer = /Tiled/i.test(layerType)
        ? new ArcGISTiledMapServiceLayer_1.default(url, { id: id, visible: visible, opacity: opacity })
        : new ArcGISDynamicMapServiceLayer_1.default(url, { id: id, visible: visible, opacity: opacity });
    var opLayer = {
        id: id,
        layer: layer,
        showLegend: true,
        showOpacitySlider: true,
        title: title,
        visibility: visible
    };
    return opLayer;
}
/**
 * Creates operational layers and group definition from GeoPortal config "layers" section.
 * @param configLayers "layers" value from GeoPortal config.
 */
function fromGeoportalLayers(configLayers) {
    var layers;
    var groups;
    if (Array.isArray(configLayers)) {
        layers = configLayers.map(configLayerToOpLayer);
        return { groups: groups, layers: layers };
    }
    layers = new Array();
    groups = {};
    for (var groupName in configLayers) {
        if (configLayers.hasOwnProperty(groupName)) {
            var layersOfGroup = configLayers[groupName];
            var opLayers = layersOfGroup.map(configLayerToOpLayer);
            opLayers.forEach(function (l) { return layers.push(l); });
            groups[groupName] = opLayers.map(function (ol) { return ol.title; });
        }
    }
    return { groups: groups, layers: layers };
}
exports.fromGeoportalLayers = fromGeoportalLayers;
